import { render, staticRenderFns } from "./EditCollectionFolderModal.vue?vue&type=template&id=4dbd1840&lang=pug&"
import script from "./EditCollectionFolderModal.vue?vue&type=script&lang=js&"
export * from "./EditCollectionFolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports